import Constant from '@/common/constant/Constant';
import { useEffect, useState } from 'react';
import { Button, TextField, Tooltip, withStyles } from '@material-ui/core';
import Storage from '@/amplify/storage';
import Utils from '@/common/utils/utils';
import FormInputWithOnChange from '../../common/form/input-with-onchange';
import RenderTooltipTitles from '../allFieldItem/RenderTooltipTitles';
import PropTypes from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import useOnDemandContentDisplay from '@/component/multiLanguage/hooks/useOnDemandContentDisplay';

TextAreaInput.propTypes = {
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    ticketId: PropTypes.any,
    formType: PropTypes.any,
    detailTicket: PropTypes.any,
    data: PropTypes.any,
    name: PropTypes.any,
    isDraftMode: PropTypes.any,
    register: PropTypes.any,
    setValue: PropTypes.any,
    setIsEdited: PropTypes.any,
    setShowButtonEditTicket: PropTypes.any,
    listFieldEdited: PropTypes.any,
    setListFieldEdited: PropTypes.any,
    setOnChangeEdit: PropTypes.any,
    isDisableOnBlur: PropTypes.any,
    defaultValue: PropTypes.any,
    label: PropTypes.any,
    isTooltipTitle: PropTypes.any,
    displayMode: PropTypes.any,
    errorlist: PropTypes.any,
    viewFromProjectOfEscalateTicket: PropTypes.any,
    hasEditFieldPermissions: PropTypes.any,
    isShowIconCopyFieldId: PropTypes.any,
    onChangeEdit: PropTypes.any
};

export default function TextAreaInput(props) {
    // Re-render when the translation dictionary loads/extends so displayed labels update.
    useTranslationSubscription();
    
    let formType = props.formType;
    let defaultValue = '';
    const isAddNewTicket = !props?.detailTicket;
    const isFieldSDAutoScript = props?.data?.sysField === Constant.SYS_FIELD.SDAUTO_SCRIPT;
    const isFieldKbXml = props?.data?.sysField === Constant.SYSTEM_FIELD.KB_XML;
    const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);
    let isTitleSdautoOnDraftMode = isFieldSDAutoScript && props?.isDraftMode;

    switch (true && !props.defaultValue) {
        case props.data.sysField === 'description' &&
            formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.DESCRIPTION;
            break;
        case props.data.sysField === 'description' && formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST.DESCRIPTION;
            break;
        case props.data.sysField === 'description' &&
            formType === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER:
            defaultValue = Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST_CUSTOMER.DESCRIPTION;
            break;
        default:
            defaultValue = props?.defaultValue ? props?.defaultValue : '';
            break;
    }

    if (props.defaultValue) {
        defaultValue = props.defaultValue;
    }

    // On-demand translation: when showing the 翻訳 view, display the translated
    // value in a read-only field WITHOUT touching the react-hook-form value, so
    // the edit form always keeps the original content.
    const { displayValue: onDemandDisplayValue, isShowingTranslation } = useOnDemandContentDisplay(
        defaultValue,
        {
            contentId: props?.detailTicket?.id,
            fieldKey: props?.name ?? props?.data?.id
        },
        props?.displayMode
    );

    useEffect(() => {
        registerAndSetValue();
    }, []);

    useEffect(() => {
        registerAndSetValue();
    }, [defaultValue]);

    const registerAndSetValue = () => {
        if (!props?.name) {
            return;
        }

        if (props.register) {
            props.register(props?.name);
        }
        if (props.setValue) {
            props.setValue(props?.name, defaultValue);
        }
    };

    const handleEditTicket = e => {
        if (props?.setIsEdited) {
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket()
            if (!props?.listFieldEdited?.includes(props?.name)) {
                props?.setListFieldEdited([...props.listFieldEdited, props?.name])
            }
            if (props?.setOnChangeEdit) {
                props?.setOnChangeEdit(!props.onChangeEdit)
            }
        }
    };

    const FlagMessageCopyLink = withStyles({
        tooltip: {
            color: '#1DA578',
            backgroundColor: '#D7F4E2',
            padding: '8px 16px',
            fontSize: '14px',
            boxShadow: '6px 5px 5px -4px rgba(0,0,0,0.3)'
        },
        arrow: {
            color: '#D7F4E2'
        }
    })(Tooltip);

    const getSDScriptS3Link = () => {
        const ticketDetail = props?.detailTicket;

        if (!ticketDetail || Utils.isEmptyObject(ticketDetail) || !ticketDetail?.id) return;

        let currentFieldId = props.name;
        if (!currentFieldId) return;

        let ticketId = ticketDetail.id
        if (ticketDetail.ticketType === Constant.TICKET_TYPE.BROADCAST_CHILD) {
            ticketId = ticketDetail.parent;
        }

        return Utils.generateS3LinkCodeSDScript(ticketId, currentFieldId)
    }

    const handleCopyLinkS3 = () => {
        let s3Link = getSDScriptS3Link();
        if (!s3Link) return;

        navigator.clipboard
            .writeText(s3Link)
            .then(() => {
                setIsShowFlagMessage(true);
                setTimeout(() => {
                    setIsShowFlagMessage(false);
                }, 1500);
            })
            .catch(err => { console.log(`handleCopyLinkSciptS3 err`, err) });
    }

    const handleViewKbSnapshot = async () => {
        const ticketDetail = props?.detailTicket;
        if (!ticketDetail || !ticketDetail?.id) return;
        const corpId = ticketDetail.affiliationOrganization;
        const projId = ticketDetail.affiliationProject;
        const ticketId = ticketDetail.id;
        const s3Key = `${corpId}/${projId}/ticket/${ticketId}/image/kboardXmlSnapshot`;
        try {
            const url = await Storage.get(s3Key, { level: 'public' });
            window.open(url, '_blank');
        } catch (err) {
            console.log('[TextAreaInput] Failed to get kboard snapshot URL:', err);
        }
    };

    const isDisableField =
        props.data.structure.publicForCustomer == 2 ||
        props.viewFromProjectOfEscalateTicket ||
        !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
        props.hasEditFieldPermissions === false;

    const renderInput = () => {
        if (isShowingTranslation) {
            return (
                <TextField
                    className={`form-control form-control-wrapTextarea ${isFieldSDAutoScript ? 'form-control-hg500' : 'form-control-hg112'}`}
                    variant="outlined"
                    value={onDemandDisplayValue ?? ''}
                    multiline
                    rows={4}
                    disabled
                    inputProps={{ className: 'fields-disabled' }}
                    data-cy="text-area-input-field-translated"
                />
            );
        }

        return (
            <FormInputWithOnChange
                name={props?.name}
                className={`form-control form-control-wrapTextarea ${isFieldSDAutoScript ? 'form-control-hg500' : 'form-control-hg112'}`}
                variant="outlined"
                defaultValue={defaultValue}
                multiline
                rows={4}
                disabled={isDisableField}
                errorlist={props?.errorlist}
                onChange={handleEditTicket}
                data-cy="text-area-input-field"
                isDisableOnBlur={props.isDisableOnBlur ? props.isDisableOnBlur : false}
            />
        );
    };

    return (
        <div className="form-addTicket">
            <div className={`cell-prod-status gap-8 ${isTitleSdautoOnDraftMode ? 'div-title-sdauto cursor-default' : ''}`}>
                {props?.isTooltipTitle ?
                    <RenderTooltipTitles {...props} /> :
                    <label className={`form-addTicket-label w-f100 ${isTitleSdautoOnDraftMode ? 'title-sdauto' : ''}`}>{props?.label} {props.data.structure.required && <span className="required">*</span>}</label>
                }
                {!isAddNewTicket && isFieldSDAutoScript && (
                    <div className={`${isTitleSdautoOnDraftMode ? '' : 'script-link'}`}>
                        <Tooltip title={tr('リンクをコピー')} arrow={true} placement="bottom">
                            <Button className="button-script cursor-pointer" onClick={handleCopyLinkS3}>
                                <FlagMessageCopyLink
                                    title={trI18n('KNOWDEMSG002')}
                                    placement="top-start"
                                    arrow={true}
                                    open={isShowFlagMessage}
                                >
                                    <img src="/assets/image/html-link-icon.svg" alt="" className="cursor-pointer" />
                                </FlagMessageCopyLink>
                            </Button>
                        </Tooltip>
                    </div>
                )}
                {!isAddNewTicket && isFieldKbXml && (
                    <div className="script-link">
                        <Tooltip title={trI18n('LABEL-KBOARD-PREVIEW')} arrow={true} placement="bottom">
                            <Button className="button-script cursor-pointer" onClick={handleViewKbSnapshot}>
                                <span className="cursor-pointer" style={{ fontSize: '16px' }}>🖼️</span>
                            </Button>
                        </Tooltip>
                    </div>
                )}
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>
            <div className="form-addTicket-input">
                {renderInput()}
            </div>
        </div>
    );
}
